import styled from '@emotion/styled';
import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaShareSquare } from 'react-icons/fa';

import EyeTicketLight from '../../../assets/EyeTicket-Light.png';
import EyeTicketDark from '../../../assets/EyeTicket.png';
import { Typography } from './Typography.jsx';

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

const IconButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  border: 2px solid ${({ colour }) => colour || 'white'};
  color: ${({ colour }) => colour || 'white'};
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ colour }) => colour || 'white'};
    color: black;
  }

  svg {
    font-size: 18px;
  }
`;

const Logo = styled.img`
  height: auto;
  width: 120px;
  margin-top: 10px;
`;

function isDarkColor(hexColor) {
  if (!hexColor) return false;
  const rgb = parseInt(hexColor.slice(1), 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = rgb & 0xff;
  return 0.299 * r + 0.587 * g + 0.114 * b < 128;
}

export const SidebarFooter = ({ colours, setToggled, deleteCookie }) => {
  const logoSrc = isDarkColor(colours?.sidebar) ? EyeTicketLight : EyeTicketDark;
  const buttonColor = colours?.font || 'white';

  return (
    <FooterContainer>
      <ButtonGroup>
        <IconButton to="/home" onClick={() => setToggled(false)} colour={buttonColor}>
          <FaHome /> Home
        </IconButton>
        <IconButton as="button" onClick={deleteCookie} colour={buttonColor}>
          <FaShareSquare /> Logout
        </IconButton>
      </ButtonGroup>
      <Typography variant="caption" color={colours.font} fontWeight={600} style={{ textAlign: 'center' }}>
        Powered By
      </Typography>
      <Logo src={logoSrc} alt="EyeTicket Logo" />
    </FooterContainer>
  );
};
